import { render, staticRenderFns } from "./planning_view.vue?vue&type=template&id=23b083aa"
import script from "./planning_view.vue?vue&type=script&lang=js"
export * from "./planning_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports